module.exports = __webpack_public_path__ + "media/images/attention-b980aa4dc2f214ef65ba9f23c705c531.svg";